import { IAbsoluteTimeConstraint } from '@sparelabs/domain-logic'
import { IPoint } from '@sparelabs/geography'
import { IListModelQueryParamValues, IModelJsonValues } from '@sparelabs/http-client-utils'

export enum BreakConflictResolution {
  None = 'none',
  AfterDropoffs = 'afterDropoffs',
  RematchOnboardRiders = 'rematchOnboardRiders',
}

export interface IDriverBreakResponse extends IModelJsonValues {
  id: string
  breakLength: number
  breakReasonId?: string | null
  address?: string | null
  location?: IPoint | null
  notes?: string | null
  timeConstraint?: IAbsoluteTimeConstraint | null
}

export interface IDriverBreakListQueryParams extends IListModelQueryParamValues {
  dutyId: string
}

export interface IDriverScheduledBreakPostBody {
  breakLength: number
  earliestStartTs: number
  latestStartTs: number
  dutyId: string
  breakReasonId?: string | null
  address?: string | null
  location?: IPoint | null
  notes?: string | null
}

export type IDriverAsapBreakPostBody = Omit<IDriverScheduledBreakPostBody, 'earliestStartTs' | 'latestStartTs'> & {
  conflictResolution?: BreakConflictResolution
  /** @deprecated Use conflictResolution instead */
  force?: boolean | null
}

export interface IDriverBreakPatchBody {
  breakLength?: number
  earliestStartTs?: number
  latestStartTs?: number
  breakReasonId?: string | null
  address?: string | null
  location?: IPoint | null
  notes?: string | null
}
